export default __webpack_public_path__ + "static/akzidenz-grotesk-bold-4d8ec26a9ffde23bcf25f764bdeeb115.woff";